export enum COMPETITIONS_DEFAULT_FIELDS {
  ZONES = 'Zones',
  REGIONS = 'Regions',
  BRANCHES = 'Branches',
  PRODUCTS = 'Products',
  ACTIVITY_TYPE = 'Activity Type',
  TARGET = 'Target',
  DESIGNATIONS = 'Designations',
}
